import React from 'react';
import cx from 'classnames';

import Text from '../../atoms/Text';
import Button from '../../atoms/Button';

import styles from './ActionSection.module.scss';
import usePresenter from './ActionSection.presenter';
import getProps from './ActionSection.props';
import { ActionSectionCombinedProps } from './types';


const ActionSection: React.FC<ActionSectionCombinedProps> = (props) => {
  const {
    className,
    classes,
    topText,
    bottomText,
    button,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.actionSection;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.textGroup, classes?.textGroup)}>
        <Text
          className={cx(styles.topText, classes?.topText)}
          {...internalProps.topText}
          {...topText}/>
        <Text
          className={cx(styles.bottomText, classes?.bottomText)}
          {...internalProps.bottomText}
          {...bottomText}/>
      </div>
      <Button
        className={cx(styles.button, classes?.button)}
        {...internalProps.button}
        {...button}/>
    </div>
  );
};

export default ActionSection;
